import { officeService } from '@/services/api/office.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { officeModel } from '@/models/api/office.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const OFFICE_MODULE = "api/office";

// ACTIONS
export const GET_ALL_OFFICE = 'getAllOffice';
export const CREATE_OFFICE = 'createOffice';
export const GET_OFFICE = 'getOffice';
export const UPDATE_OFFICE = 'updateOffice';
export const UPDATE_OFFICE_STATUS = 'updateOfficeStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_OFFICE_SUCCESS = "allOfficeSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_OFFICE_SUCCESS = "getOfficeSuccess";

export const actions = {
    [GET_ALL_OFFICE]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        officeService
            .getAll(filter)
            .then((result) => {
                commit(ALL_OFFICE_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_OFFICE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return officeService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_OFFICE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_OFFICE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return officeService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_OFFICE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_OFFICE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return officeService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_OFFICE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_OFFICE_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return officeService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_OFFICE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_OFFICE_SUCCESS](state, {data}) {
        let office = data.data || [];
        state.list.data = office;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = office.map(item => officeModel(item));
        }
    },
    [GET_OFFICE_SUCCESS](state, data) {
        state.details = officeModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};

